const SalesMap = () => import("@/views/base/SalesMap.vue");
const SalesRep = () => import("@/views/base/SalesRep.vue");
const viewSale = () => import("@/views/base/SalesView.vue");

const salesRoute = {
  mainRoute: "base/SalesRep",
  children: [
    {
      path: "base/SalesRep",
      name: "Sales Rep",
      component: SalesRep
    },
    {
      path: "base/SalesMap",
      name: "Sales Map",
      component: SalesMap
    },
    {
      path: "viewSale",
      name: "View Sale",
      component: viewSale,
      props(route) {
        return route.query || {};
      }
    }
  ]
};

export default salesRoute;
